module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    staticClass: "page-element",
    attrs: {
      "col": "",
      "lg": "4",
      "md": "6",
      "sm": "12"
    }
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Nowe hasło")]), _vm._v(" "), (_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "login__field"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_data"
    }
  }, [_vm._v("Hasło")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "login__field"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_data"
    }
  }, [_vm._v("Powtórz hasło")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "login__field"
  }, [_c('my-button', {
    attrs: {
      "text": "Zatwierdź hasło",
      "icon": "tick",
      "action": _vm.submit
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dd8172e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/security/newPassword.vue
// module id = 821
// module chunks = 0